<msi-content-modal #modal [items]="[{}]" [modalRef]="modalRef">
	<div class="msi-content-modal-item config-modal">
		<div class="config-modal-left msi-flex-col with-space-between">
			<div class="top-bar">
				<msi-icon name="ic_cards_all"></msi-icon>
				@if (viewId) {
					<p i18n="Page title while editing workspace" class="modal-title">Edit "{{ originalTitle }}"</p>
				} @else {
					<p i18n class="modal-title">Create a new workspace</p>
				}
			</div>
			<div class="name-view">
				<div class="input-label">
					<p i18n class="input-label-name">Name your workspace</p>
					<p i18n class="input-label-small-italics">Apply a custom name.</p>
				</div>
				<input
					id="workspaceTitleInput"
					class="msi-input name-view-input"
					type="text"
					[(ngModel)]="title"
					(ngModelChange)="titleInputChanged()" />
				<div class="title-input-error-message">
					{{ titleInputErrorMessage }}
				</div>
			</div>
			<div class="select-container">
				<div class="input-label">
					<p i18n class="input-label-name">Select your criteria</p>
					<p i18n class="input-label-small-italics">Select all that apply</p>
				</div>
				<p i18n="Number of selected items" class="selected-text" [class.selected-text-active]="numSelectedCriteria > 0">
					{{ numSelectedCriteria }} selected
				</p>
			</div>
			<div class="left-side-controls">
				<msi-checkbox
					i18n
					(change)="selectAll($event)"
					[checked]="allSelected"
					[indeterminate]="numSelectedCriteria > 0 && !allSelected">
					All triggers and actions
				</msi-checkbox>
				<msi-treeview class="product-list" [class.hidden]="allSelected">
					<!-- Products -->
					@for (product of products; track product.productId) {
						<msi-item
							id="productCriteria-{{ product.productId }}"
							[collapsable]="product.keys.length"
							isCollapsed="true">
							<msi-checkbox [hidden]="true"></msi-checkbox>
							<msi-checkbox
								id="criteriaCheckbox-{{ product.productId }}"
								(change)="selectProduct(product.productId, product.checked)"
								[(ngModel)]="product.checked"
								[indeterminate]="product.childrenChecked">
								{{ product.productName }}
							</msi-checkbox>

							<!-- Keys -->
							@for (key of product.keys; track key) {
								<msi-item
									id="productCriteriaKey-{{ key.keyName }}"
									[collapsable]="true"
									[hidden]="product.checked"
									isCollapsed="true">
									<msi-checkbox [hidden]="true"></msi-checkbox>
									{{ key.keyName | sentenceCase }}

									<!-- Values -->
									@for (value of key.values; track value) {
										<msi-item>
											<msi-checkbox
												(change)="selectCriteria(product.productId, key.keyName, value.value, value.checked)"
												[(ngModel)]="value.checked">
												{{ value.value }}
											</msi-checkbox>
										</msi-item>
									}
								</msi-item>
							}
						</msi-item>
					}
				</msi-treeview>
			</div>
			<div class="cancel-save-button-container">
				<button
					i18n
					id="cancelWorkspaceEditButton"
					class="msi-btn msi-btn-secondary cancel-save-buttons"
					(click)="cancelClickHandler()">
					Cancel
				</button>
				<button
					i18n
					id="saveWorkspaceEditButton"
					class="msi-btn cancel-save-buttons"
					[disabled]="!isValidTitleAdded"
					(click)="saveClickHandler()">
					Save
				</button>
			</div>
		</div>
		<!-- Preview pane -->
		<div class="config-modal-right">
			<div class="top-bar">
				<p i18n>Preview</p>
			</div>
			<div class="triggers-actions">
				<div class="triggers-actions-inner">
					<div i18n class="triggers-actions-inner-header">Triggers</div>
					<div class="triggers-actions-inner-body">
						@for (trigger of selectedTriggers; track trigger) {
							<div>
								<div class="trigger-component">
									<div class="trigger-action-name">
										<p class="capability-name">{{ trigger.name }}</p>
										<p class="small-text capability-matching-criteria">{{ trigger.matchingCriteria }}</p>
									</div>
									<p class="product-name small-text">{{ trigger.productName }}</p>
								</div>
							</div>
						}
					</div>
				</div>
				<div class="triggers-actions-inner">
					<div i18n class="triggers-actions-inner-header">Actions</div>
					<div class="triggers-actions-inner-body">
						@for (action of selectedActions; track action) {
							<div>
								<div class="trigger-component">
									<div class="trigger-action-name">
										<p class="capability-name">{{ action.name }}</p>
										<p class="small-text capability-matching-criteria">{{ action.matchingCriteria }}</p>
									</div>
									<p class="product-name small-text">{{ action.productName }}</p>
								</div>
							</div>
						}
					</div>
				</div>
			</div>
		</div>
	</div>
</msi-content-modal>

<!-- Copyright (c) Motorola Solutions Inc. All Rights Reserved. -->
